import { useRecoilValue } from 'recoil';

import { MiniMap } from '@/components/modules/mini-map';
import { usePaths } from '@/hooks/use-paths';
import { MAP_LINE_COLOR_UNKNOWN, MAP_LINE_STYLE_DASHED_LIGHT, MODE_WATER } from '@/lib/constants';
import { LocationModel } from '@/lib/models/location/types';
import { locationsState } from '@/state/locations';
import { PortSequence } from '@/types';
import { pathsToMapPaths } from '@/utils/mapping';

import { createLineMapMarkers } from './utils';

export interface LineMapProps {
  lineLocations: LocationModel[];
  portSequence: PortSequence[];
}

const LineMap = ({ lineLocations, portSequence }: LineMapProps) => {
  const locations = useRecoilValue(locationsState);
  const stopIds = portSequence.map((port) => port.id);
  const stopLocations = stopIds.map((id) => locations[id]);

  // Get Paths using location ids, first location is added to end to handle loops
  const { paths: rawLocationPaths } = usePaths([...lineLocations, lineLocations[0]], MODE_WATER, true);
  const { paths: rawStopPaths } = usePaths(stopLocations, MODE_WATER, true);

  const linePaths = pathsToMapPaths(rawLocationPaths, {
    pathColor: MAP_LINE_COLOR_UNKNOWN,
    pathStyle: MAP_LINE_STYLE_DASHED_LIGHT,
    hasOutline: false,
    zIndex: 1,
  });
  const stopPaths = pathsToMapPaths(rawStopPaths);

  const markers = createLineMapMarkers(lineLocations, portSequence);

  return <MiniMap paths={[...linePaths, ...stopPaths]} markers={markers} />;
};

export { LineMap };
